module.exports = __webpack_public_path__ + "img/2025-09-19c_2.1cabe1ad.jpg";